import { Table } from "antd";
import React from "react";

import { useTicketPoolsTable } from "./hooks";
import { TicketPoolsTableProps } from "./types";

const TicketPoolsTable: React.FC<TicketPoolsTableProps> = (props) => {
  const table = useTicketPoolsTable(props);

  return <Table rowKey="id" {...table} pagination={false} />;
};

export default TicketPoolsTable;
